import { Button, Col, Form, Input, InputNumber, Modal, notification, Row, Select, Space, Tooltip } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ModalName } from "../../../../constant/enumerations";
import { setExpConsolDtlEdit, setExpConsolDtlList, setModalEsidVisibility } from "../../../../actions/esidExportAction";
import { createUUID, removeAccents } from "../../../../utils/utils";
import { EditOutlined } from "@ant-design/icons";

export const EditConsolModel = () => {
  const { t } = useTranslation("common");
  const [form] = Form.useForm();
  const visibility = useSelector((state) => state.esidExport.modal[`${ModalName.ConsolModal}`]);
  const esidSelected = useSelector(state => state.esidExport.esidExpSelected);
  const consolDtlList = useSelector(state => state.esidExport.consolDtlList);
  const consolDtlEdit = useSelector(state => state.esidExport.consolDtlEdit);
  const { cmpList } = useSelector((state) => state.esidExport);
  const { airports } = useSelector((state) => state.airport);
  const dispatch = useDispatch();

  const shipperOptions = useMemo(() => {
    return cmpList?.filter(x => x.codCtcTyp === 'SHP')?.map(x => ({
      label: x.namCtc,
      value: x.id,
    })) || [];
  }, [cmpList]);

  const consigneeOptions = useMemo(() => {
    return cmpList?.filter(x => x.codCtcTyp === 'CNE')?.map(x => ({
      label: x.namCtc,
      value: x.id,
    })) || [];
  }, [cmpList]);

  useEffect(() => {
    form.setFieldsValue({
      codHwbNum: consolDtlEdit?.codHwbNum,
      qrCod: consolDtlEdit?.qrCod,
      qtyPcs: consolDtlEdit?.qtyPcs,
      qtyWgt: consolDtlEdit?.qtyWgt,
      natureOfGoods: consolDtlEdit?.natureOfGoods,
      codOri: consolDtlEdit?.codOri,
      codFds: consolDtlEdit?.codFds,
    });
    const hawbList = consolDtlEdit?.['hawbCtcList'] || [];
    const shipper = hawbList?.find(x => x.codCtcTyp === 'SHP') || {};
    const consignee = hawbList?.find(x => x.codCtcTyp === 'CNE') || {};
    form.setFieldsValue({
      shipperId: shipper?.ctcId,
      shipperName: shipper?.namCtc,
      shipperAddress: shipper?.desAddStt,
      shipperTaxCode: shipper?.codTaxCmp,
      shipperPhone: shipper?.desPhone,
      consigneeId: consignee?.ctcId,
      consigneeName: consignee?.namCtc,
      consigneeAddress: consignee?.desAddStt,
      consigneeTaxCode: consignee?.codTaxCmp,
      consigneePhone: consignee?.desPhone
    });
    if (consolDtlEdit) {
      setEditShipper(!shipper?.ctcId);
      setEditConsignee(!consignee?.ctcId);
    }
    // eslint-disable-next-line
  }, [consolDtlEdit])

  const closeSelf = () => {
    dispatch(setExpConsolDtlEdit(null));
    dispatch(setModalEsidVisibility({ [`${ModalName.ConsolModal}`]: false }));
  };

  const saveConsolDtl = (values, closeModal = true) => {
    if (!checkValidAirport(values?.codOri)) {
      notification.error({
        message: 'Thông báo',
        description: 'Điểm xuất phát không hợp lệ.'
      });
      return;
    }
    if (!checkValidAirport(values?.codFds)) {
      notification.error({
        message: 'Thông báo',
        description: 'Điểm đến không hợp lệ.'
      });
      return;
    }
    if (!values?.hawbCtcList) {
        const hawbList = consolDtlEdit?.hawbCtcList || [];
        const shipperExists = hawbList?.find(x => x.codCtcTyp === 'SHP') || {};
        const consigneeExists = hawbList?.find(x => x.codCtcTyp === 'CNE') || {};
        const shipper = {
          ctcId: values.shipperId,
          namCtc: values.shipperName,
          desAddStt: values.shipperAddress,
          codTaxCmp: values.shipperTaxCode,
          desPhone: values.shipperPhone,
          codCtcTyp: 'SHP',
          namCmp1: removeAccents(values.shipperName),
          desAddStt1: removeAccents(values.shipperAddress),
        }
        const consignee = {
          ctcId: values.consigneeId,
          namCtc: values.consigneeName,
          desAddStt: values.consigneeAddress,
          codTaxCmp: values.consigneeTaxCode,
          desPhone: values.consigneePhone,
          codCtcTyp: 'CNE',
          namCmp1: removeAccents(values.consigneeName),
          desAddStt1: removeAccents(values.consigneeAddress),
        }
        delete values.shipperName;
        delete values.shipperAddress;
        delete values.shipperTaxCode;
        delete values.shipperPhone;
        delete values.consigneeName;
        delete values.consigneeAddress;
        delete values.consigneeTaxCode;
        delete values.consigneePhone;
        values.hawbCtcList = [];
        if (shipper?.namCtc) {
          values.hawbCtcList = [ {...shipperExists, ...shipper} ];
        }
        if (consignee?.namCtc) {
          values.hawbCtcList.push({ ...consigneeExists, ...consignee });
        }
    }
    const shipper = values.hawbCtcList?.find(x => x.codCtcTyp === 'SHP') || {};
    const consignee = values.hawbCtcList?.find(x => x.codCtcTyp === 'CNE') || {};
    let hasError = false;
    let errorMessage = '';
    if (!shipper?.namCtc || !shipper?.desAddStt) {
      hasError = true;
      errorMessage = 'THONG TIN NGUOI GUI KHONG HOP LE';
    }
    if (!consignee?.namCtc || !consignee?.desAddStt) {
      hasError = true;
      errorMessage = errorMessage ? errorMessage + '; THONG TIN NGUOI NHAN KHONG HOP LE' :  'THONG TIN NGUOI NHAN KHONG HOP LE';
    }
    values.hasError = hasError;
    values.errorMessage = errorMessage;
    //
    const dtlList  = [...consolDtlList];
    const dataDtl = {
      esidId: esidSelected.id,
      codAwbPfx: esidSelected.codAwbPfx,
      codAwbNum: esidSelected.codAwbNum,
      codAwbSfx: esidSelected.codAwbSfx,
      codSts: 'NY',
      ...consolDtlEdit,
      ...values
    }
    if (!dataDtl.key) {
      dataDtl.key = createUUID();
      dtlList.push(dataDtl);
    } else {
      const idx = dtlList.findIndex(x => x.key === dataDtl.key);
      if (idx > -1) {
        dtlList[idx] = dataDtl;
      }
    }
    console.log({dtlList});
    
    dispatch(setExpConsolDtlList(dtlList));
    if (closeModal) {
      closeSelf();
    }
  }

  const checkValidAirport = (code) => {
    if (!code) return false;
    return !!airports?.find(x => x.codApt === code || x.codCty === code);
  }

  const saveAndCreateConsolDtl = async () => {
    let values = await form.validateFields();
    if (!checkValidAirport(values?.codOri)) {
      notification.error({
        message: 'Thông báo',
        description: 'Điểm xuất phát không hợp lệ.'
      });
      return;
    }
    if (!checkValidAirport(values?.codFds)) {
      notification.error({
        message: 'Thông báo',
        description: 'Điểm đến không hợp lệ.'
      });
      return;
    }
    const hawbList = consolDtlEdit?.hawbCtcList || [];
    const shipperExists = hawbList?.find(x => x.codCtcTyp === 'SHP') || {};
    const consigneeExists = hawbList?.find(x => x.codCtcTyp === 'CNE') || {};
    const shipper = {
      ctcId: values.shipperId,
      namCtc: values.shipperName,
      desAddStt: values.shipperAddress,
      codTaxCmp: values.shipperTaxCode,
      desPhone: values.shipperPhone,
      codCtcTyp: 'SHP',
      namCmp1: removeAccents(values.shipperName),
      desAddStt1: removeAccents(values.shipperAddress),
    }
    const consignee = {
      ctcId: values.consigneeId,
      namCtc: values.consigneeName,
      desAddStt: values.consigneeAddress,
      codTaxCmp: values.consigneeTaxCode,
      desPhone: values.consigneePhone,
      codCtcTyp: 'CNE',
      namCmp1: removeAccents(values.consigneeName),
      desAddStt1: removeAccents(values.consigneeAddress),
    }
    delete values.shipperId;
    delete values.shipperName;
    delete values.shipperAddress;
    delete values.shipperTaxCode;
    delete values.shipperPhone;
    delete values.consigneeId;
    delete values.consigneeName;
    delete values.consigneeAddress;
    delete values.consigneeTaxCode;
    delete values.consigneePhone;
    let hasError = false;
    let errorMessage = '';
    if (!shipper?.namCtc || !shipper?.desAddStt) {
      hasError = true;
      errorMessage = 'THONG TIN NGUOI GUI KHONG HOP LE';
    }
    if (!consignee?.namCtc || !consignee?.desAddStt) {
      hasError = true;
      errorMessage = errorMessage ? errorMessage + '; THONG TIN NGUOI NHAN KHONG HOP LE' :  'THONG TIN NGUOI NHAN KHONG HOP LE';
    }
    values.hasError = hasError;
    values.errorMessage = errorMessage;
    values.hawbCtcList = [];
    if (shipper?.namCtc) {
      values.hawbCtcList = [ {...shipperExists, ...shipper} ];
    }
    if (consignee?.namCtc) {
      values.hawbCtcList.push({ ...consigneeExists, ...consignee });
    }
    saveConsolDtl(values, false);
    form.resetFields();
    setEditShipper(false);
    setEditConsignee(false);
    dispatch(setExpConsolDtlEdit(null));
  }

  const handleShipperChange = (value) => {
    const selected = cmpList?.find(x => x.id === value);
    form.setFieldsValue({
      shipperId: selected?.id || '',
      shipperName: selected?.namCtc || '',
      shipperAddress: selected?.desAddStt || '',
      shipperTaxCode: selected?.codTaxCmp || '',
      shipperPhone: selected?.desPhone || ''
    });
  };

  const handleConsigneeChange = (value) => {
    const selected = cmpList?.find(x => x.id === value);
    form.setFieldsValue({
      consigneeId: selected?.id || '',
      consigneeName: selected?.namCtc || '',
      consigneeAddress: selected?.desAddStt || '',
      consigneeTaxCode: selected?.codTaxCmp || '',
      consigneePhone: selected?.desPhone || ''
    });
  };

  const [editShipper, setEditShipper] = useState(false);
  const [editConsignee, setEditConsignee] = useState(false);

  return (
    <>
      <Modal
        visible={visibility}
        centered
        onCancel={closeSelf}
        footer={null}
        width={'60%'}
        title={t('consolLabels.editConsolDtl')}>
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            codHwbNum: consolDtlEdit?.codHwbNum,
            qrCod: consolDtlEdit?.qrCod,
            qtyPcs: consolDtlEdit?.qtyPcs || 0,
            qtyWgt: consolDtlEdit?.qtyWgt,
            natureOfGoods: consolDtlEdit?.natureOfGoods,
          }}
          onFinish={saveConsolDtl}
          requiredMark>
          <Row gutter={[16, 0]}>
            <Col span={12}>
              <Form.Item
                name="codOri"
                label={t('consolLabels.codOri')}
                required
                rules={[
                  {
                    required: true,
                    message: t('dangerousGood.errorInfo.required'),
                  },
                ]}>
                <Input name="codOri" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="codFds"
                label={t('consolLabels.codFds')}
                rules={[
                  {
                    required: true,
                    message: t('dangerousGood.errorInfo.required'),
                  },
                ]}>
                <Input name="codFds" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 0]}>
            <Col span={12}>
              <Form.Item
                name="codHwbNum"
                label={t('consolLabels.hawb')}
                required
                rules={[
                  {
                    required: true,
                    message: t('dangerousGood.errorInfo.required'),
                  },
                ]}>
                <Input name="codHwbNum" maxLength={12} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="qrCod" label={t('consolLabels.qrCode')}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 0]}>
            <Col span={12}>
              <Form.Item
                name="qtyPcs"
                label={t('consolLabels.qtyPcs')}
                required
                rules={[
                  {
                    required: true,
                    message: t('dangerousGood.errorInfo.required'),
                  },
                ]}>
                <InputNumber min={0} style={{ width: '100%', height: '32px' }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="qtyWgt" label={t('consolLabels.qtyWgt')}>
                <InputNumber min={0} style={{ width: '100%', height: '32px' }} />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            name="natureOfGoods"
            label={t('consolLabels.nog')}
            required
            rules={[
              {
                required: true,
                message: t('dangerousGood.errorInfo.required'),
              },
            ]}>
            <Input />
          </Form.Item>
          <Row gutter={[16, 0]}>
            <Col span={12}>
              <div
                style={{
                  border: '1px solid #ccc',
                  padding: '16px',
                  marginRight: '8px',
                  width: '100%',
                }}>
                <Form.Item label={editShipper ? 'Nhập thêm mới / sửa thông tin người gửi' : t('consolLabels.shipper')} style={{ fontWeight: 'bold' }}>
                  <Row gutter={8}>
                    <Col flex="auto">
                      <Form.Item
                        hidden={editShipper}
                        name="shipperId"
                        noStyle
                        rules={[
                          { required: false, message: t('dangerousGood.errorInfo.required') },
                        ]}>
                        <Select
                          showSearch
                          options={shipperOptions}
                          filterOption={(input, option) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                          }
                          onChange={handleShipperChange}
                        />
                      </Form.Item>
                      <Form.Item
                        noStyle
                        hidden={!editShipper}
                        name="shipperName"
                        rules={[
                          { required: false, message: t('dangerousGood.errorInfo.required') },
                        ]}>
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Tooltip title={'Thêm mới / sửa thông tin người gửi'}>
                        <Button
                          onClick={() => setEditShipper(!editShipper)}
                          icon={<EditOutlined />}
                        />
                      </Tooltip>
                    </Col>
                  </Row>
                </Form.Item>
                <Form.Item
                  label={t('consolLabels.address')}
                  name="shipperAddress"
                  rules={[{ required: false, message: t('dangerousGood.errorInfo.required') }]}>
                  <Input.TextArea rows={2} />
                </Form.Item>
                <Form.Item label={t('consolLabels.taxCode')} name="shipperTaxCode">
                  <Input />
                </Form.Item>
                <Form.Item label={t('consolLabels.phone')} name={'shipperPhone'}>
                  <Input />
                </Form.Item>
              </div>
            </Col>
            <Col span={12} style={{ paddingRight: '8px' }}>
              <div style={{ border: '1px solid #ccc', padding: '16px', width: '100%' }}>
                <Form.Item label={editConsignee ? 'Nhập thêm mới / sửa thông tin người nhận' : t('consolLabels.consignee')} style={{ fontWeight: 'bold' }}>
                  <Row gutter={8}>
                    <Col flex="auto">
                      <Form.Item
                        hidden={editConsignee}
                        name="consigneeId"
                        noStyle
                        style={{ fontWeight: 'bold' }}
                        rules={[
                          { required: false, message: t('dangerousGood.errorInfo.required') },
                        ]}>
                        <Select
                          showSearch
                          options={consigneeOptions}
                          filterOption={(input, option) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                          }
                          onChange={handleConsigneeChange}
                        />
                      </Form.Item>
                      <Form.Item
                        hidden={!editConsignee}
                        name="consigneeName"
                        noStyle
                        style={{ fontWeight: 'bold' }}
                        rules={[
                          { required: false, message: t('dangerousGood.errorInfo.required') },
                        ]}>
                            <Input name="consigneeName"/>
                      </Form.Item>
                    </Col>
                    <Col>
                      <Tooltip title={'Thêm mới / sửa thông tin người nhận'}>
                        <Button
                          onClick={() => setEditConsignee(!editConsignee)}
                          icon={<EditOutlined />}
                        />
                      </Tooltip>
                    </Col>
                  </Row>
                </Form.Item>
                <Form.Item
                  name="consigneeAddress"
                  label={t('consolLabels.address')}
                  rules={[{ required: false, message: t('dangerousGood.errorInfo.required') }]}>
                  <Input.TextArea rows={2} />
                </Form.Item>
                <Form.Item name="consigneeTaxCode" label={t('consolLabels.taxCode')}>
                  <Input />
                </Form.Item>
                <Form.Item label={t('consolLabels.phone')} name={'consigneePhone'}>
                  <Input />
                </Form.Item>
              </div>
            </Col>
          </Row>
          <Form.Item style={{ display: 'flex', justifyContent: 'center', marginTop: '8px' }}>
            <Space style={{ justifyContent: 'center', width: '100%' }}>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: 'fit-content' }}
                disabled={consolDtlEdit?.codSts === 'OK'}
                className="submitBtn">
                {t('consolLabels.save')}
              </Button>
              <Button
                style={{ width: 'fit-content' }}
                className="submitBtn"
                disabled={consolDtlEdit?.codSts === 'OK'}
                onClick={saveAndCreateConsolDtl}>
                {t('consolLabels.saveAndAdd')}
              </Button>
              <Button style={{ width: 'fit-content' }} className="submitBtn" onClick={closeSelf}>
                {t('consolLabels.cancel')}
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
